import { Alert, Button, Stack } from '@mui/material';

const COPY = {
  AWARDED: { severity: 'success', title: 'Subasta adjudicada' },
  EXPIRED: { severity: 'warning', title: 'Tiempo agotado. Sin adjudicación automática.' },
  CONFLICT: { severity: 'error', title: 'Conflicto' },
};

export const AuctionLiveStatus = ({ status, message, onBack, extraAction }) => {
  if (!status || status === 'OPEN') {
    return null;
  }
  const meta = COPY[status] || COPY.CONFLICT;
  return (
    <Alert
      severity={meta.severity}
      role="status"
      aria-live={status === 'AWARDED' ? 'assertive' : 'polite'}
      sx={{ mb: 2 }}
    >
      <strong>{meta.title}</strong>
      {message ? <div>{message}</div> : null}
      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
        {onBack && (
          <Button size="small" variant="outlined" onClick={onBack}>
            Volver al listado
          </Button>
        )}
        {extraAction}
      </Stack>
    </Alert>
  );
};
